import React from "react";

function Footer() {
  return (
    <footer className="flex justify-between items-center py-10 px-8 max-w-3xl mx-auto">
      <div>
        <p className="font-display font-bold text-navy text-sm">Helin Okcu</p>
        <p className="text-[11px] text-warm-gray mt-0.5">Berlin, Germany</p>
      </div>
      <div className="flex gap-4">
        {[
          { label: "LinkedIn", href: "https://linkedin.com/in/helinokcu" },
          { label: "GitHub", href: "https://github.com/xhokcu" },
          { label: "helinokcu.com", href: "https://helinokcu.com" },
        ].map((link) => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[12px] text-warm-gray hover:text-coral transition-colors duration-200 no-underline"
          >
            {link.label}
          </a>
        ))}
      </div>
    </footer>
  );
}

export default Footer;
